import React from 'react';
/**
 * We are doing null with non-null assertion operator to trick Typescript to allow null as default value.
 * We don't want to set dummy default values, that's why setting null.
 * This context is used every where using useAIExperienceCommonDataContext hook.
 * We check first if it's value is null, throws error if it's null to prevent random runtime error.
 */
export var AIExperienceCommonDataContext = /*#__PURE__*/React.createContext(
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
null);
export var useAIExperienceCommonDataContext = function useAIExperienceCommonDataContext() {
  var contextData = React.useContext(AIExperienceCommonDataContext);
  if (!contextData) {
    throw new Error('Attempted to access AIExperienceCommonDataContext before its value is set');
  }
  return contextData;
};